import React from 'react'
import { Dimmer, Loader, Image, Segment, Grid } from 'semantic-ui-react'

const LoadingPage = () => (
  <Segment className="loadercontainer">
    <Dimmer active inverted>
      <Loader size='large'/>
    </Dimmer>
  </Segment>
)

export default LoadingPage